module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCA4MzJhMzIgMzIgMCAwIDEgMCA2NEgxNjBhMzIgMzIgMCAwIDEgMC02NGg3MDR6TTUzNyAxNTAuN2wyNDAuOSAyNDIuOGEzMiAzMiAwIDAgMS0yMi43IDU0LjVINjQwdjI4OGEzMiAzMiAwIDAgMS0zMiAzMmgtMTkyYTMyIDMyIDAgMCAxLTMyLTMydi0yODhIMjY5LjdhMzIgMzIgMCAwIDEtMjIuNS01NC43bDI0NC42LTI0Mi44YTMyIDMyIDAgMCAxIDQ1LjMgMC4yeiIgZmlsbD0iIzAiIHAtaWQ9IjM0MTQiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Commit 1-filled.svg
// module id = 9Vhq
// module chunks = 74